/* internal */
import { useBlockProps, RichText } from '@wordpress/block-editor';
import { __ } from '@wordpress/i18n';

export default function save( { attributes } ) {
		
	const { backgroundColor, content, title} = attributes;	
	const blockProps = useBlockProps.save();
		
	return (			
			<div { ...blockProps }
				style={ { backgroundColor: backgroundColor  } }
			>
				
				<span class="dashicons dashicons-minus hide"></span>
				<span class="dashicons dashicons-plus-alt show"></span>
            
			    <RichText.Content 
					tagName="div" 
					value={ title } 
                    className='title'
					/>
           		<RichText.Content 
					tagName="div" 
					value={ content } 
                    className='hidden'
					/>
                
			</div>
		);
	
	}
